import { useSelector } from '../dependencies';

import { membershipsListSelector } from '../../../services/selectors';

export default function useMemberships() {
    return useSelector(membershipsListSelector);
}
